module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/suggestions/suggestion_close-81da414b6a1f53f2f80e2aaf7b0e348f.png";